import { render, staticRenderFns } from "./CtaBtn.vue?vue&type=template&id=44895103"
import script from "./CtaBtn.vue?vue&type=script&lang=js"
export * from "./CtaBtn.vue?vue&type=script&lang=js"
import style0 from "./CtaBtn.vue?vue&type=style&index=0&id=44895103&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports